import { useEffect, useRef } from 'react';

type UsePageVisibilityParams = {
  onVisible?: () => void;
  onHidden?: () => void;
};

export const usePageVisibility = ({
  onVisible,
  onHidden,
}: UsePageVisibilityParams): void => {
  const onVisibleRef = useRef(onVisible);
  const onHiddenRef = useRef(onHidden);
  onVisibleRef.current = onVisible;
  onHiddenRef.current = onHidden;

  useEffect(() => {
    const sync = () => {
      if (document.hidden) {
        onHiddenRef.current?.();
      } else {
        onVisibleRef.current?.();
      }
    };
    sync();
    document.addEventListener('visibilitychange', sync);
    return () => document.removeEventListener('visibilitychange', sync);
  }, []);
};
